import React, { useEffect, useState } from "react";
import {Card,Button} from 'react-bootstrap'
import post from './assets/post.png'
import userLogo from './assets/user.png'
import exam from './assets/exam.jpg'
import feedback from './assets/feedback.png'
import attendance from './assets/attendance.jpg'
import certiPDF from './assets/CERTIFICATE_4_QR.pdf'
import certificate from './assets/certificate.png'
import heading from './assets/meetra_long.png'
import './GuideCard.css'
import fire from "./firebase/config";
import 'firebase/firestore';
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
// import certiSS from './assets/certi_ss.png'
import certiSS from './assets/MEETRA_CERTIFICATE_5.jpg'
import { jsPDF } from "jspdf";
import { Modal } from 'semantic-ui-react';
import Footer from './Footer'

function exampleReducer(state, action) {
    switch (action.type) {
      case 'close':
        return { open: false }
      case 'open':
        return { open: true, size: action.size }
      default:
        throw new Error('Unsupported action...')
    }
  }

export default function Dashboard(props) {
    const history = useHistory();
    const signOutUser = () =>{
        fire.auth().signOut().then(function(){
            history.push({pathname:'/Login'})
        }).catch(function(error){

        });
    }
    // const [user, setUser] = useState();
  const user = fire.auth().currentUser;
  const [info , setInfo] = useState([]);
  
  const [docID, setDocID] = useState(null);
  const[isOpen, setIsOpen] = useState(false);
  const [state, dispatch] = React.useReducer(exampleReducer, {
    open: false,
    size: undefined,
  })
  const { open, size } = state
  const db = fire.firestore();
  useEffect(() => {
    
    Fetchdata();
  },[]);
  let data=[];
    const Fetchdata = () => {
        db.collection("users").where("email","==",user?.email).get().then((querySnapshot) => {
            // Loop through the data and store
            // it in array to display
            querySnapshot.forEach((doc) => {
                setDocID(`${doc.id}`)
                var data = doc.data();
                setInfo(arr => [...arr , data]);
                console.log(data.name);
            });
            // console.log(user.email);
            
        }).catch({
    
        });
    }
    
        var userName;
        var trainingProg;
        var singleTraining;
        info.map((data)=>{
            if(data.email === user.email){
                userName = data.name;
                // console.log("DocID is: "+docID);
                trainingProg = data.trainingProg;
                // singleTraining=trainingProg.split('; ');
                // trainingProg = singleTraining[0];
            }
        }
        )
        // var ref = db.collection('users').doc("Rr6cu2xWHEFSOHHuuJ0v");
        // var setWithMerge = ref.update({
        //     trainingProg: trainingProg
        // }, {merge:trainingProg});
        let PreTrainingButton, OnlineTrainingButton, PostTrainingButton, FeedbackButton, CertificateButton;
        // if(trainingProg === "Orientation on JJM with DPR preparation (29/07/2021)"){
        //     PreTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PreTraining'})} type="submit">Attempt Pre-Questionnaire</Button></center>
        //     OnlineTrainingButton = <center><a href='https://meet.google.com/jnm-pbjg-fhe' target="_blank"><Button disabled className="btn1-disabled" variant="outlined" type="submit">Join Google Meet</Button></a></center>
        //     PostTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PostTraining'})} type="submit">Attempt Post-Questionnaire</Button></center>
        //     FeedbackButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/Feedback'})} type="submit">Provide Feedback</Button></center>
        //     CertificateButton = <center><Button className="btn1" variant="outlined" onClick={() => 
        //         {
        //             var doc = new jsPDF('l', 'pt')
        //             doc.addImage(certiSS,'png', 10, 10, 820, 570)
        //             // doc.setTextColor(0,117,195)
        //             doc.setFontSize(14)
        //             doc.setFont('arial','normal')
        //             doc.text('This is to certify Mr./Ms.',140,346)
        //             doc.setFont('arial','bold')
        //             doc.text(userName,285,346)
        //             doc.setFont('arial','normal')
        //             doc.text('has successfully completed his/her training in',140,372)
        //             doc.setFont('arial','bold')
        //             // doc.text(trainingProg,140,400)
        //             doc.text('Orientation on JJM with DPR preparation',400,372)
        //             doc.text('Date: ',140,410)
        //             doc.setFont('arial','normal')
        //             doc.text('29/07/2021',180,410)
        //             doc.setFont('arial','bold')
        //             doc.text('Dy. Director, MEETRA ',140,450)
        //             doc.text('Director, MEETRA ',550,450)
        //             doc.setFont('arial','normal')
        //             // doc.text('29/07/2021',180,450)
        //             doc.save('Certificate.pdf')
        //             dispatch({ type: 'open', size: 'mini' })
        //         }
        //     } target="_blank" type="submit">Get Certificate</Button></center>
        // }
        // else if(trainingProg === "Orientation on JJM with DPR preparation (30/07/2021)"){
        //     PreTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PreTraining'})} target="_blank" type="submit">Attempt Pre-Questionnaire</Button></center>
        //     OnlineTrainingButton = <center><a href='https://meet.google.com/iaq-qzzf-hzg' target="_blank"><Button disabled className="btn1-disabled" variant="outlined" type="submit">Join Google Meet</Button></a></center>
        //     PostTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PostTraining'})} type="submit">Attempt Post-Questionnaire</Button></center>
        //     FeedbackButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/Feedback'})} type="submit">Provide Feedback</Button></center>
        //     CertificateButton = <center><Button className="btn1" variant="outlined" onClick={() => 
        //         {
        //             var doc = new jsPDF('l', 'pt')
        //             doc.addImage(certiSS,'png', 10, 10, 820, 570)
        //             // doc.setTextColor(0,117,195)
        //             doc.setFontSize(14)
        //             doc.setFont('arial','normal')
        //             doc.text('This is to certify Mr./Ms.',140,346)
        //             doc.setFont('arial','bold')
        //             doc.text(userName,285,346)
        //             doc.setFont('arial','normal')
        //             doc.text('has successfully completed his/her training in',140,372)
        //             doc.setFont('arial','bold')
        //             // doc.text(trainingProg,140,400)
        //             doc.text('Orientation on JJM with DPR preparation',400,372)
        //             doc.text('Date: ',140,410)
        //             doc.setFont('arial','normal')
        //             doc.text('30/07/2021',180,410)
        //             doc.setFont('arial','bold')
        //             doc.text('Dy. Director, MEETRA ',140,450)
        //             doc.text('Director, MEETRA ',550,450)
        //             doc.setFont('arial','normal')
        //             // doc.text('29/07/2021',180,450)
        //             doc.save('Certificate.pdf')
        //             dispatch({ type: 'open', size: 'mini' })
        //         }
        //     } target="_blank" type="submit">Get Certificate</Button></center>
        // }
        // else if(trainingProg === "Hydraulic Modelling of Distribution System (02/08/2021)"){ 
        //     PreTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PreTraining'})} type="submit">Attempt Pre-Questionnaire</Button></center>
        //     OnlineTrainingButton = <center><a href='https://meet.google.com/jhr-ctrm-axv' target="_blank"><Button disabled className="btn1-disabled" variant="outlined" type="submit">Join Google Meet</Button></a></center>
        //     PostTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PostTraining'})} type="submit">Attempt Post-Questionnaire</Button></center>
        //     FeedbackButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/Feedback'})}  type="submit">Provide Feedback</Button></center>
        //     CertificateButton = <center><Button className="btn1" variant="outlined" onClick={() => 
        //         {
        //             var doc = new jsPDF('l', 'pt')
        //             doc.addImage(certiSS,'png', 10, 10, 820, 570)
        //             // doc.setTextColor(0,117,195)
        //             doc.setFontSize(14)
        //             doc.setFont('arial','normal')
        //             doc.text('This is to certify Mr./Ms.',140,346)
        //             doc.setFont('arial','bold')
        //             doc.text(userName,285,346)
        //             doc.setFont('arial','normal')
        //             doc.text('has successfully completed his/her training in',140,372)
        //             doc.setFont('arial','bold')
        //             // doc.text(trainingProg,140,400)
        //             doc.text('Hydraulic Modelling of Distribution System',400,372)
        //             doc.text('Date: ',140,410)
        //             doc.setFont('arial','normal')
        //             doc.text('2 & 3 August, 2021',180,410)
        //             doc.setFont('arial','bold')
        //             doc.text('Dy. Director, MEETRA ',140,450)
        //             doc.text('Director, MEETRA ',550,450)
        //             doc.setFont('arial','normal')
        //             // doc.text('29/07/2021',180,450)
        //             doc.save('Certificate.pdf')
        //             dispatch({ type: 'open', size: 'mini' })
        //         }
        //     } target="_blank" type="submit">Get Certificate</Button></center>
        // }
        // else if(trainingProg === "Hydraulic Modelling of Distribution System (04-05/08/2021)"){ 
        //     PreTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PreTraining'})} type="submit">Attempt Pre-Questionnaire</Button></center>
        //     OnlineTrainingButton = <center><a href='https://meet.google.com/grm-jytf-xik' target="_blank"><Button disabled className="btn1-disabled" variant="outlined" type="submit">Join Google Meet</Button></a></center>
        //     PostTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PostTraining'})} type="submit">Attempt Post-Questionnaire</Button></center>
        //     FeedbackButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/Feedback'})}  type="submit">Provide Feedback</Button></center>
        //     CertificateButton = <center><Button className="btn1" variant="outlined" onClick={() => 
        //         {
        //             var doc = new jsPDF('l', 'pt')
        //             doc.addImage(certiSS,'png', 10, 10, 820, 570)
        //             // doc.setTextColor(0,117,195)
        //             doc.setFontSize(14)
        //             doc.setFont('arial','normal')
        //             doc.text('This is to certify Mr./Ms.',140,346)
        //             doc.setFont('arial','bold')
        //             doc.text(userName,285,346)
        //             doc.setFont('arial','normal')
        //             doc.text('has successfully completed his/her training in',140,372)
        //             doc.setFont('arial','bold')
        //             // doc.text(trainingProg,140,400)
        //             doc.text('Hydraulic Modelling of Distribution System',400,372)
        //             doc.text('Date: ',140,410)
        //             doc.setFont('arial','normal')
        //             doc.text('4 & 5 August, 2021',180,410)
        //             doc.setFont('arial','bold')
        //             doc.text('Dy. Director, MEETRA ',140,450)
        //             doc.text('Director, MEETRA ',550,450)
        //             doc.setFont('arial','normal')
        //             // doc.text('29/07/2021',180,450)
        //             doc.save('Certificate.pdf')
        //             dispatch({ type: 'open', size: 'mini' })
        //         }
        //     } target="_blank" type="submit">Get Certificate</Button></center>
        // }
        // else if(trainingProg === "Orientation on JJM with DPR preparation (06/08/2021)"){
        //     PreTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PreTraining'})} target="_blank" type="submit">Attempt Pre-Questionnaire</Button></center>
        //     OnlineTrainingButton = <center><a href='https://meet.google.com/gxz-yvye-uyw' target="_blank"><Button disabled className="btn1-disabled" variant="outlined" type="submit">Join Google Meet</Button></a></center>
        //     PostTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PostTraining'})} type="submit">Attempt Post-Questionnaire</Button></center>
        //     FeedbackButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/Feedback'})} type="submit">Provide Feedback</Button></center>
        //     CertificateButton = <center><Button className="btn1" variant="outlined" onClick={() => 
        //         {
        //             var doc = new jsPDF('l', 'pt')
        //             doc.addImage(certiSS,'png', 10, 10, 820, 570)
        //             // doc.setTextColor(0,117,195)
        //             doc.setFontSize(14)
        //             doc.setFont('arial','normal')
        //             doc.text('This is to certify Mr./Ms.',140,346)
        //             doc.setFont('arial','bold')
        //             doc.text(userName,285,346)
        //             doc.setFont('arial','normal')
        //             doc.text('has successfully completed his/her training in',140,372)
        //             doc.setFont('arial','bold')
        //             // doc.text(trainingProg,140,400)
        //             doc.text('Orientation on JJM with DPR preparation',400,372)
        //             doc.text('Date: ',140,410)
        //             doc.setFont('arial','normal')
        //             doc.text('06/08/2021',180,410)
        //             doc.setFont('arial','bold')
        //             doc.text('Dy. Director, MEETRA ',140,450)
        //             doc.text('Director, MEETRA ',550,450)
        //             doc.setFont('arial','normal')
        //             // doc.text('29/07/2021',180,450)
        //             doc.save('Certificate.pdf')
        //             dispatch({ type: 'open', size: 'mini' })
        //         }
        //     } target="_blank" type="submit">Get Certificate</Button></center>
        // }
        // else if(trainingProg === "Hydraulic Modelling of Distribution System (09/08/2021)"){ 
        //     PreTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PreTraining'})} type="submit">Attempt Pre-Questionnaire</Button></center>
        //     OnlineTrainingButton = <center><a href='https://meet.google.com/czw-gggd-hae' target="_blank"><Button disabled className="btn1-disabled" variant="outlined" type="submit">Join Google Meet</Button></a></center>
        //     PostTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PostTraining'})} type="submit">Attempt Post-Questionnaire</Button></center>
        //     FeedbackButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/Feedback'})}  type="submit">Provide Feedback</Button></center>
        //     CertificateButton = <center><Button className="btn1" variant="outlined" onClick={() => 
        //         {
        //             var doc = new jsPDF('l', 'pt')
        //             doc.addImage(certiSS,'png', 10, 10, 820, 570)
        //             // doc.setTextColor(0,117,195)
        //             doc.setFontSize(14)
        //             doc.setFont('arial','normal')
        //             doc.text('This is to certify Mr./Ms.',140,346)
        //             doc.setFont('arial','bold')
        //             doc.text(userName,285,346)
        //             doc.setFont('arial','normal')
        //             doc.text('has successfully completed his/her training in',140,372)
        //             doc.setFont('arial','bold')
        //             // doc.text(trainingProg,140,400)
        //             doc.text('Hydraulic Modelling of Distribution System',400,372)
        //             doc.text('Date: ',140,410)
        //             doc.setFont('arial','normal')
        //             doc.text('9 & 10 August, 2021',180,410)
        //             doc.setFont('arial','bold')
        //             doc.text('Dy. Director, MEETRA ',140,450)
        //             doc.text('Director, MEETRA ',550,450)
        //             doc.setFont('arial','normal')
        //             // doc.text('29/07/2021',180,450)
        //             doc.save('Certificate.pdf')
        //             dispatch({ type: 'open', size: 'mini' })
        //         }
        //     } target="_blank" type="submit">Get Certificate</Button></center>
        // }
        // else if(trainingProg === "Hydraulic Modelling of Distribution System (11-12/08/2021)"){ 
        //     PreTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PreTraining'})} type="submit">Attempt Pre-Questionnaire</Button></center>
        //     OnlineTrainingButton = <center><a href='https://meet.google.com/jcq-jtmi-pgx' target="_blank"><Button disabled className="btn1-disabled" variant="outlined" type="submit">Join Google Meet</Button></a></center>
        //     PostTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PostTraining'})} type="submit">Attempt Post-Questionnaire</Button></center>
        //     FeedbackButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/Feedback'})}  type="submit">Provide Feedback</Button></center>
        //     CertificateButton = <center><Button className="btn1" variant="outlined" onClick={() => 
        //         {
        //             var doc = new jsPDF('l', 'pt')
        //             doc.addImage(certiSS,'png', 10, 10, 820, 570)
        //             // doc.setTextColor(0,117,195)
        //             doc.setFontSize(14)
        //             doc.setFont('arial','normal')
        //             doc.text('This is to certify Mr./Ms.',140,346)
        //             doc.setFont('arial','bold')
        //             doc.text(userName,285,346)
        //             doc.setFont('arial','normal')
        //             doc.text('has successfully completed his/her training in',140,372)
        //             doc.setFont('arial','bold')
        //             // doc.text(trainingProg,140,400)
        //             doc.text('Hydraulic Modelling of Distribution System',400,372)
        //             doc.text('Date: ',140,410)
        //             doc.setFont('arial','normal')
        //             doc.text('11 & 12 August, 2021',180,410)
        //             doc.setFont('arial','bold')
        //             doc.text('Dy. Director, MEETRA ',140,450)
        //             doc.text('Director, MEETRA ',550,450)
        //             doc.setFont('arial','normal')
        //             // doc.text('29/07/2021',180,450)
        //             doc.save('Certificate.pdf')
        //             dispatch({ type: 'open', size: 'mini' })
        //         }
        //     } target="_blank" type="submit">Get Certificate</Button></center>
        // }
        // else if(trainingProg === "Orientation on JJM with DPR preparation (13/08/2021) - Morning"){
        //     PreTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PreTraining'})} target="_blank" type="submit">Attempt Pre-Questionnaire</Button></center>
        //     OnlineTrainingButton = <center><a href='https://meet.google.com/ptp-ajdn-hhv' target="_blank"><Button disabled className="btn1-disabled" variant="outlined" type="submit">Join Google Meet</Button></a></center>
        //     PostTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PostTraining'})} type="submit">Attempt Post-Questionnaire</Button></center>
        //     FeedbackButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/Feedback'})} type="submit">Provide Feedback</Button></center>
        //     CertificateButton = <center><Button  className="btn1" variant="outlined" onClick={() => 
        //         {
        //             var doc = new jsPDF('l', 'pt')
        //             doc.addImage(certiSS,'png', 10, 10, 820, 570)
        //             // doc.setTextColor(0,117,195)
        //             doc.setFontSize(14)
        //             doc.setFont('arial','normal')
        //             doc.text('This is to certify Mr./Ms.',140,346)
        //             doc.setFont('arial','bold')
        //             doc.text(userName,285,346)
        //             doc.setFont('arial','normal')
        //             doc.text('has successfully completed his/her training in',140,372)
        //             doc.setFont('arial','bold')
        //             // doc.text(trainingProg,140,400)
        //             doc.text('Orientation on JJM with DPR preparation',400,372)
        //             doc.text('Date: ',140,410)
        //             doc.setFont('arial','normal')
        //             doc.text('13/08/2021',180,410)
        //             doc.setFont('arial','bold')
        //             doc.text('Dy. Director, MEETRA ',140,450)
        //             doc.text('Director, MEETRA ',550,450)
        //             doc.setFont('arial','normal')
        //             // doc.text('29/07/2021',180,450)
        //             doc.save('Certificate.pdf')
        //             dispatch({ type: 'open', size: 'mini' })
        //         }
        //     } target="_blank" type="submit">Get Certificate</Button></center>
        // }
        // else if(trainingProg === "Orientation on JJM with DPR preparation (13/08/2021) - Afternoon"){
        //     PreTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PreTraining'})} target="_blank" type="submit">Attempt Pre-Questionnaire</Button></center>
        //     OnlineTrainingButton = <center><a href='https://meet.google.com/pgn-cwho-gnm' target="_blank"><Button disabled className="btn1-disabled" variant="outlined" type="submit">Join Google Meet</Button></a></center>
        //     PostTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PostTraining'})} type="submit">Attempt Post-Questionnaire</Button></center>
        //     FeedbackButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/Feedback'})} type="submit">Provide Feedback</Button></center>
        //     CertificateButton = <center><Button className="btn1" variant="outlined" onClick={() => 
        //         {
        //             var doc = new jsPDF('l', 'pt')
        //             doc.addImage(certiSS,'png', 10, 10, 820, 570)
        //             // doc.setTextColor(0,117,195)
        //             doc.setFontSize(14)
        //             doc.setFont('arial','normal')
        //             doc.text('This is to certify Mr./Ms.',140,346)
        //             doc.setFont('arial','bold')
        //             doc.text(userName,285,346)
        //             doc.setFont('arial','normal')
        //             doc.text('has successfully completed his/her training in',140,372)
        //             doc.setFont('arial','bold')
        //             // doc.text(trainingProg,140,400)
        //             doc.text('Orientation on JJM with DPR preparation',400,372)
        //             doc.text('Date: ',140,410)
        //             doc.setFont('arial','normal')
        //             doc.text('13/08/2021',180,410)
        //             doc.setFont('arial','bold')
        //             doc.text('Dy. Director, MEETRA ',140,450)
        //             doc.text('Director, MEETRA ',550,450)
        //             doc.setFont('arial','normal')
        //             // doc.text('29/07/2021',180,450)
        //             doc.save('Certificate.pdf')
        //             dispatch({ type: 'open', size: 'mini' })
        //         }
        //     } target="_blank" type="submit">Get Certificate</Button></center>
        // }
        
    if(trainingProg === "Hydraulic Modelling of Distribution System (17-18/08/2021)"){
        PreTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PreTraining', state: {trainingProg:trainingProg}})} target="_blank" type="submit">Attempt Pre-Questionnaire</Button></center>
        OnlineTrainingButton = <center><a href='https://meet.google.com/snw-fkgv-yya' target="_blank"><Button disabled className="btn1-disabled" variant="outlined" type="submit">Join Google Meet</Button></a></center>
        PostTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PostTraining', state: {trainingProg:trainingProg}})} type="submit">Attempt Post-Questionnaire</Button></center>
        FeedbackButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/Feedback'})} type="submit">Provide Feedback</Button></center>
        CertificateButton = <center><Button className="btn1" variant="outlined" onClick={() => 
            {
                var doc = new jsPDF('l', 'pt')
                doc.addImage(certiSS,'png', 10, 10, 820, 570)
                // doc.setTextColor(0,117,195)
                doc.setFontSize(14)
                doc.setFont('arial','normal')
                doc.text('This is to certify Mr./Ms.',140,346)
                doc.setFont('arial','bold')
                doc.text(userName,285,346)
                doc.setFont('arial','normal')
                doc.text('has successfully completed his/her training in',140,372)
                doc.setFont('arial','bold')
                // doc.text(trainingProg,140,400)
                doc.text('Hydraulic Modelling of Distribution System',400,372)
                doc.text('Date: ',140,410)
                doc.setFont('arial','normal')
                doc.text('17 & 18 August, 2021',180,410)
                doc.setFont('arial','bold')
                doc.text('Dy. Director, MEETRA ',140,450)
                doc.text('Director, MEETRA ',550,450)
                doc.setFont('arial','normal')
                // doc.text('29/07/2021',180,450)
                doc.save('Certificate.pdf')
                dispatch({ type: 'open', size: 'mini' })
            }
        } target="_blank" type="submit">Get Certificate</Button></center>
    }
    else if(trainingProg === "Hydraulic Modelling of Distribution System (20-21/08/2021)"){
        PreTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PreTraining', state: {trainingProg:trainingProg}})} target="_blank" type="submit">Attempt Pre-Questionnaire</Button></center>
        OnlineTrainingButton = <center><a href='https://meet.google.com/oev-ypxj-ihr' target="_blank"><Button disabled className="btn1-disabled" variant="outlined" type="submit">Join Google Meet</Button></a></center>
        PostTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PostTraining', state: {trainingProg:trainingProg}})} type="submit">Attempt Post-Questionnaire</Button></center>
        FeedbackButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/Feedback'})} type="submit">Provide Feedback</Button></center>
        CertificateButton = <center><Button className="btn1" variant="outlined" onClick={() => 
            {
                var doc = new jsPDF('l', 'pt')
                doc.addImage(certiSS,'png', 10, 10, 820, 570)
                // doc.setTextColor(0,117,195)
                doc.setFontSize(14)
                doc.setFont('arial','normal')
                doc.text('This is to certify Mr./Ms.',140,346)
                doc.setFont('arial','bold')
                doc.text(userName,285,346)
                doc.setFont('arial','normal')
                doc.text('has successfully completed his/her training in',140,372)
                doc.setFont('arial','bold')
                // doc.text(trainingProg,140,400)
                doc.text('Hydraulic Modelling of Distribution System',400,372)
                doc.text('Date: ',140,410)
                doc.setFont('arial','normal')
                doc.text('20 & 21 August, 2021',180,410)
                doc.setFont('arial','bold')
                doc.text('Dy. Director, MEETRA ',140,450)
                doc.text('Director, MEETRA ',550,450)
                doc.setFont('arial','normal')
                // doc.text('29/07/2021',180,450)
                doc.save('Certificate.pdf')
                dispatch({ type: 'open', size: 'mini' })
            }
        } target="_blank" type="submit">Get Certificate</Button></center>
    }
    else if(trainingProg === "Orientation on JJM with DPR preparation (23/08/2021)"){
        PreTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PreTraining', state: {trainingProg:trainingProg}})} target="_blank" type="submit">Attempt Pre-Questionnaire</Button></center>
        OnlineTrainingButton = <center><a href='https://meet.google.com/xzn-htnj-hes' target="_blank"><Button disabled className="btn1-disabled" variant="outlined" type="submit">Join Google Meet</Button></a></center>
        PostTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PostTraining', state: {trainingProg:trainingProg}})} type="submit">Attempt Post-Questionnaire</Button></center>
        FeedbackButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/Feedback'})} type="submit">Provide Feedback</Button></center>
        CertificateButton = <center><Button className="btn1" variant="outlined" onClick={() => 
                {
                    var doc = new jsPDF('l', 'pt')
                    doc.addImage(certiSS,'png', 10, 10, 820, 570)
                    // doc.setTextColor(0,117,195)
                    doc.setFontSize(14)
                    doc.setFont('arial','normal')
                    doc.text('This is to certify Mr./Ms.',140,346)
                    doc.setFont('arial','bold')
                    doc.text(userName,285,346)
                    doc.setFont('arial','normal')
                    doc.text('has successfully completed his/her training in',140,372)
                    doc.setFont('arial','bold')
                    // doc.text(trainingProg,140,400)
                    doc.text('Orientation on JJM with DPR preparation',400,372)
                    doc.text('Date: ',140,410)
                    doc.setFont('arial','normal')
                    doc.text('23/08/2021',180,410)
                    doc.setFont('arial','bold')
                    doc.text('Dy. Director, MEETRA ',140,450)
                    doc.text('Director, MEETRA ',550,450)
                    doc.setFont('arial','normal')
                    // doc.text('29/07/2021',180,450)
                    doc.save('Certificate.pdf')
                    dispatch({ type: 'open', size: 'mini' })
                }
            } target="_blank" type="submit">Get Certificate</Button></center>
        }
        else if(trainingProg === "Hydraulic Modelling of Distribution System (24-25/08/2021)"){
            PreTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PreTraining', state: {trainingProg:trainingProg}})} target="_blank" type="submit">Attempt Pre-Questionnaire</Button></center>
            OnlineTrainingButton = <center><a href='https://meet.google.com/eht-wnaf-sxn' target="_blank"><Button disabled className="btn1-disabled" variant="outlined" type="submit">Join Google Meet</Button></a></center>
            PostTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PostTraining', state: {trainingProg:trainingProg}})} type="submit">Attempt Post-Questionnaire</Button></center>
            FeedbackButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/Feedback'})} type="submit">Provide Feedback</Button></center>
            CertificateButton = <center><Button className="btn1" variant="outlined" onClick={() => 
                {
                    var doc = new jsPDF('l', 'pt')
                    doc.addImage(certiSS,'png', 10, 10, 820, 570)
                    // doc.setTextColor(0,117,195)
                    doc.setFontSize(14)
                    doc.setFont('arial','normal')
                    doc.text('This is to certify Mr./Ms.',140,346)
                    doc.setFont('arial','bold')
                    doc.text(userName,285,346)
                    doc.setFont('arial','normal')
                    doc.text('has successfully completed his/her training in',140,372)
                    doc.setFont('arial','bold')
                    // doc.text(trainingProg,140,400)
                    doc.text('Hydraulic Modelling of Distribution System',400,372)
                    doc.text('Date: ',140,410)
                    doc.setFont('arial','normal')
                    doc.text('24 & 25 August, 2021',180,410)
                    doc.setFont('arial','bold')
                    doc.text('Dy. Director, MEETRA ',140,450)
                    doc.text('Director, MEETRA ',550,450)
                    doc.setFont('arial','normal')
                    // doc.text('29/07/2021',180,450)
                    doc.save('Certificate.pdf')
                    dispatch({ type: 'open', size: 'mini' })
                }
            } target="_blank" type="submit">Get Certificate</Button></center>
        }
        else if(trainingProg === "Orientation on JJM with DPR preparation (26/08/2021)"){
            PreTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PreTraining', state: {trainingProg:trainingProg}})} target="_blank" type="submit">Attempt Pre-Questionnaire</Button></center>
            OnlineTrainingButton = <center><a href='https://meet.google.com/ukz-yzkf-bku' target="_blank"><Button disabled className="btn1-disabled" variant="outlined" type="submit">Join Google Meet</Button></a></center>
            PostTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PostTraining', state: {trainingProg:trainingProg}})} type="submit">Attempt Post-Questionnaire</Button></center>
            FeedbackButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/Feedback'})} type="submit">Provide Feedback</Button></center>
            CertificateButton = <center><Button className="btn1" variant="outlined" onClick={() => 
                    {
                        var doc = new jsPDF('l', 'pt')
                        doc.addImage(certiSS,'png', 10, 10, 820, 570)
                        // doc.setTextColor(0,117,195)
                        doc.setFontSize(14)
                        doc.setFont('arial','normal')
                        doc.text('This is to certify Mr./Ms.',140,346)
                        doc.setFont('arial','bold')
                        doc.text(userName,285,346)
                        doc.setFont('arial','normal')
                        doc.text('has successfully completed his/her training in',140,372)
                        doc.setFont('arial','bold')
                        // doc.text(trainingProg,140,400)
                        doc.text('Orientation on JJM with DPR preparation',400,372)
                        doc.text('Date: ',140,410)
                        doc.setFont('arial','normal')
                        doc.text('26/08/2021',180,410)
                        doc.setFont('arial','bold')
                        doc.text('Dy. Director, MEETRA ',140,450)
                        doc.text('Director, MEETRA ',550,450)
                        doc.setFont('arial','normal')
                        // doc.text('29/07/2021',180,450)
                        doc.save('Certificate.pdf')
                        dispatch({ type: 'open', size: 'mini' })
                    }
                } target="_blank" type="submit">Get Certificate</Button></center>
            }
            else if(trainingProg === "Orientation on JJM with DPR preparation (27/08/2021)"){
                PreTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PreTraining', state: {trainingProg:trainingProg}})} target="_blank" type="submit">Attempt Pre-Questionnaire</Button></center>
                OnlineTrainingButton = <center><a href='https://meet.google.com/fbk-yony-agm' target="_blank"><Button disabled className="btn1-disabled" variant="outlined" type="submit">Join Google Meet</Button></a></center>
                PostTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PostTraining', state: {trainingProg:trainingProg}})} type="submit">Attempt Post-Questionnaire</Button></center>
                FeedbackButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/Feedback'})} type="submit">Provide Feedback</Button></center>
                CertificateButton = <center><Button className="btn1" variant="outlined" onClick={() => 
                        {
                            var doc = new jsPDF('l', 'pt')
                            doc.addImage(certiSS,'png', 10, 10, 820, 570)
                            // doc.setTextColor(0,117,195)
                            doc.setFontSize(14)
                            doc.setFont('arial','normal')
                            doc.text('This is to certify Mr./Ms.',140,346)
                            doc.setFont('arial','bold')
                            doc.text(userName,285,346)
                            doc.setFont('arial','normal')
                            doc.text('has successfully completed his/her training in',140,372)
                            doc.setFont('arial','bold')
                            // doc.text(trainingProg,140,400)
                            doc.text('Orientation on JJM with DPR preparation',400,372)
                            doc.text('Date: ',140,410)
                            doc.setFont('arial','normal')
                            doc.text('27/08/2021',180,410)
                            doc.setFont('arial','bold')
                            doc.text('Dy. Director, MEETRA ',140,450)
                            doc.text('Director, MEETRA ',550,450)
                            doc.setFont('arial','normal')
                            // doc.text('29/07/2021',180,450)
                            doc.save('Certificate.pdf')
                            dispatch({ type: 'open', size: 'mini' })
                        }
                    } target="_blank" type="submit">Get Certificate</Button></center>
                }
                else if(trainingProg === "Hydraulic Modelling of Distribution System (30-31/08/2021)"){
                    PreTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PreTraining', state: {trainingProg:trainingProg}})} target="_blank" type="submit">Attempt Pre-Questionnaire</Button></center>
                    OnlineTrainingButton = <center><a href='https://meet.google.com/fqs-imbr-yas' target="_blank"><Button disabled className="btn1-disabled" variant="outlined" type="submit">Join Google Meet</Button></a></center>
                    PostTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PostTraining', state: {trainingProg:trainingProg}})} type="submit">Attempt Post-Questionnaire</Button></center>
                    FeedbackButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/Feedback'})} type="submit">Provide Feedback</Button></center>
                    CertificateButton = <center><Button className="btn1" variant="outlined" onClick={() => 
                        {
                            var doc = new jsPDF('l', 'pt')
                            doc.addImage(certiSS,'png', 10, 10, 820, 570)
                            // doc.setTextColor(0,117,195)
                            doc.setFontSize(14)
                            doc.setFont('arial','normal')
                            doc.text('This is to certify Mr./Ms.',140,346)
                            doc.setFont('arial','bold')
                            doc.text(userName,285,346)
                            doc.setFont('arial','normal')
                            doc.text('has successfully completed his/her training in',140,372)
                            doc.setFont('arial','bold')
                            // doc.text(trainingProg,140,400)
                            doc.text('Hydraulic Modelling of Distribution System',400,372)
                            doc.text('Date: ',140,410)
                            doc.setFont('arial','normal')
                            doc.text('30 & 31 August, 2021',180,410)
                            doc.setFont('arial','bold')
                            doc.text('Dy. Director, MEETRA ',140,450)
                            doc.text('Director, MEETRA ',550,450)
                            doc.setFont('arial','normal')
                            // doc.text('29/07/2021',180,450)
                            doc.save('Certificate.pdf')
                            dispatch({ type: 'open', size: 'mini' })
                        }
                    } target="_blank" type="submit">Get Certificate</Button></center>
                }
                else if(trainingProg === "Hydraulic Modelling of Distribution System (01-02/09/2021)"){
                    PreTrainingButton = <center><Button className="btn1" variant="outlined" onClick={() => history.push({pathname:'/PreTraining', state: {trainingProg:trainingProg}})} target="_blank" type="submit">Attempt Pre-Questionnaire</Button></center>
                    OnlineTrainingButton = <center><a href='https://meet.google.com/mwe-gtfj-mic' target="_blank"><Button className="btn1" variant="outlined" type="submit">Join Google Meet</Button></a></center>
                    PostTrainingButton = <center><Button className="btn1" variant="outlined" onClick={() => history.push({pathname:'/PostTraining', state: {trainingProg:trainingProg}})} type="submit">Attempt Post-Questionnaire</Button></center>
                    FeedbackButton = <center><Button className="btn1" variant="outlined" onClick={() => history.push({pathname:'/Feedback'})} type="submit">Provide Feedback</Button></center>
                    CertificateButton = <center><Button  className="btn1" variant="outlined" onClick={() => 
                        {
                            var doc = new jsPDF('l', 'pt')
                            doc.addImage(certiSS,'png', 10, 10, 820, 570)
                            // doc.setTextColor(0,117,195)
                            doc.setFontSize(14)
                            doc.setFont('arial','normal')
                            doc.text('This is to certify Mr./Ms.',140,346)
                            doc.setFont('arial','bold')
                            doc.text(userName,285,346)
                            doc.setFont('arial','normal')
                            doc.text('has successfully completed his/her training in',140,372)
                            doc.setFont('arial','bold')
                            // doc.text(trainingProg,140,400)
                            doc.text('Hydraulic Modelling of Distribution System',400,372)
                            doc.text('Date: ',140,410)
                            doc.setFont('arial','normal')
                            doc.text('1 & 2 September, 2021',180,410)
                            doc.setFont('arial','bold')
                            doc.text('Dy. Director, MEETRA ',140,450)
                            doc.text('Director, MEETRA ',550,450)
                            doc.setFont('arial','normal')
                            // doc.text('29/07/2021',180,450)
                            doc.save('Certificate.pdf')
                            dispatch({ type: 'open', size: 'mini' })
                        }
                    } target="_blank" type="submit">Get Certificate</Button></center>
                }
                else if(trainingProg === "Orientation on JJM with DPR preparation (03/09/2021)"){
                    PreTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PreTraining', state: {trainingProg:trainingProg}})} target="_blank" type="submit">Attempt Pre-Questionnaire</Button></center>
                    OnlineTrainingButton = <center><a href='https://meet.google.com/uee-mfqo-twk' target="_blank"><Button disabled className="btn1-disabled" variant="outlined" type="submit">Join Google Meet</Button></a></center>
                    PostTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PostTraining', state: {trainingProg:trainingProg}})} type="submit">Attempt Post-Questionnaire</Button></center>
                    FeedbackButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/Feedback'})} type="submit">Provide Feedback</Button></center>
                    CertificateButton = <center><Button className="btn1" variant="outlined" onClick={() => 
                            {
                                var doc = new jsPDF('l', 'pt')
                                doc.addImage(certiSS,'png', 10, 10, 820, 570)
                                // doc.setTextColor(0,117,195)
                                doc.setFontSize(14)
                                doc.setFont('arial','normal')
                                doc.text('This is to certify Mr./Ms.',140,346)
                                doc.setFont('arial','bold')
                                doc.text(userName,285,346)
                                doc.setFont('arial','normal')
                                doc.text('has successfully completed his/her training in',140,372)
                                doc.setFont('arial','bold')
                                // doc.text(trainingProg,140,400)
                                doc.text('Orientation on JJM with DPR preparation',400,372)
                                doc.text('Date: ',140,410)
                                doc.setFont('arial','normal')
                                doc.text('03/09/2021',180,410)
                                doc.setFont('arial','bold')
                                doc.text('Dy. Director, MEETRA ',140,450)
                                doc.text('Director, MEETRA ',550,450)
                                doc.setFont('arial','normal')
                                // doc.text('29/07/2021',180,450)
                                doc.save('Certificate.pdf')
                                dispatch({ type: 'open', size: 'mini' })
                            }
                        } target="_blank" type="submit">Get Certificate</Button></center>
                    }
                    else if(trainingProg === "Orientation on JJM with DPR preparation (04/09/2021)"){
                        PreTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PreTraining', state: {trainingProg:trainingProg}})} target="_blank" type="submit">Attempt Pre-Questionnaire</Button></center>
                        OnlineTrainingButton = <center><a href='https://meet.google.com/byi-wonn-mig' target="_blank"><Button disabled className="btn1-disabled" variant="outlined" type="submit">Join Google Meet</Button></a></center>
                        PostTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PostTraining', state: {trainingProg:trainingProg}})} type="submit">Attempt Post-Questionnaire</Button></center>
                        FeedbackButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/Feedback'})} type="submit">Provide Feedback</Button></center>
                        CertificateButton = <center><Button className="btn1" variant="outlined" onClick={() => 
                                {
                                    var doc = new jsPDF('l', 'pt')
                                    doc.addImage(certiSS,'png', 10, 10, 820, 570)
                                    // doc.setTextColor(0,117,195)
                                    doc.setFontSize(14)
                                    doc.setFont('arial','normal')
                                    doc.text('This is to certify Mr./Ms.',140,346)
                                    doc.setFont('arial','bold')
                                    doc.text(userName,285,346)
                                    doc.setFont('arial','normal')
                                    doc.text('has successfully completed his/her training in',140,372)
                                    doc.setFont('arial','bold')
                                    // doc.text(trainingProg,140,400)
                                    doc.text('Orientation on JJM with DPR preparation',400,372)
                                    doc.text('Date: ',140,410)
                                    doc.setFont('arial','normal')
                                    doc.text('04/09/2021',180,410)
                                    doc.setFont('arial','bold')
                                    doc.text('Dy. Director, MEETRA ',140,450)
                                    doc.text('Director, MEETRA ',550,450)
                                    doc.setFont('arial','normal')
                                    // doc.text('29/07/2021',180,450)
                                    doc.save('Certificate.pdf')
                                    dispatch({ type: 'open', size: 'mini' })
                                }
                            } target="_blank" type="submit">Get Certificate</Button></center>
                        }
                        else if(trainingProg === "Orientation on JJM with DPR preparation (06/09/2021)"){
                            PreTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PreTraining', state: {trainingProg:trainingProg}})} target="_blank" type="submit">Attempt Pre-Questionnaire</Button></center>
                            OnlineTrainingButton = <center><a href='https://meet.google.com/fjx-prwf-hab' target="_blank"><Button disabled className="btn1-disabled" variant="outlined" type="submit">Join Google Meet</Button></a></center>
                            PostTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PostTraining', state: {trainingProg:trainingProg}})} type="submit">Attempt Post-Questionnaire</Button></center>
                            FeedbackButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/Feedback'})} type="submit">Provide Feedback</Button></center>
                            CertificateButton = <center><Button className="btn1" variant="outlined" onClick={() => 
                                    {
                                        var doc = new jsPDF('l', 'pt')
                                        doc.addImage(certiSS,'png', 10, 10, 820, 570)
                                        // doc.setTextColor(0,117,195)
                                        doc.setFontSize(14)
                                        doc.setFont('arial','normal')
                                        doc.text('This is to certify Mr./Ms.',140,346)
                                        doc.setFont('arial','bold')
                                        doc.text(userName,285,346)
                                        doc.setFont('arial','normal')
                                        doc.text('has successfully completed his/her training in',140,372)
                                        doc.setFont('arial','bold')
                                        // doc.text(trainingProg,140,400)
                                        doc.text('Orientation on JJM with DPR preparation',400,372)
                                        doc.text('Date: ',140,410)
                                        doc.setFont('arial','normal')
                                        doc.text('06/09/2021',180,410)
                                        doc.setFont('arial','bold')
                                        doc.text('Dy. Director, MEETRA ',140,450)
                                        doc.text('Director, MEETRA ',550,450)
                                        doc.setFont('arial','normal')
                                        // doc.text('29/07/2021',180,450)
                                        doc.save('Certificate.pdf')
                                        dispatch({ type: 'open', size: 'mini' })
                                    }
                                } target="_blank" type="submit">Get Certificate</Button></center>
                            }
            else if(trainingProg === "Orientation on JJM with DPR preparation (07/09/2021)"){
                PreTrainingButton = <center><Button className="btn1" variant="outlined" onClick={() => history.push({pathname:'/PreTraining', state: {trainingProg:trainingProg}})} target="_blank" type="submit">Attempt Pre-Questionnaire</Button></center>
                OnlineTrainingButton = <center><a href='https://meet.google.com/hdo-kcvw-zct' target="_blank"><Button className="btn1" variant="outlined" type="submit">Join Google Meet</Button></a></center>
                PostTrainingButton = <center><Button className="btn1" variant="outlined" onClick={() => history.push({pathname:'/PostTraining', state: {trainingProg:trainingProg}})} type="submit">Attempt Post-Questionnaire</Button></center>
                FeedbackButton = <center><Button className="btn1" variant="outlined" onClick={() => history.push({pathname:'/Feedback'})} type="submit">Provide Feedback</Button></center>
                CertificateButton = <center><Button className="btn1" variant="outlined" onClick={() => 
                        {
                            var doc = new jsPDF('l', 'pt')
                            doc.addImage(certiSS,'png', 10, 10, 820, 570)
                            // doc.setTextColor(0,117,195)
                            doc.setFontSize(14)
                            doc.setFont('arial','normal')
                            doc.text('This is to certify Mr./Ms.',140,346)
                            doc.setFont('arial','bold')
                            doc.text(userName,285,346)
                            doc.setFont('arial','normal')
                            doc.text('has successfully completed his/her training in',140,372)
                            doc.setFont('arial','bold')
                            // doc.text(trainingProg,140,400)
                            doc.text('Orientation on JJM with DPR preparation',400,372)
                            doc.text('Date: ',140,410)
                            doc.setFont('arial','normal')
                            doc.text('07/09/2021',180,410)
                            doc.setFont('arial','bold')
                            doc.text('Dy. Director, MEETRA ',140,450)
                            doc.text('Director, MEETRA ',550,450)
                            doc.setFont('arial','normal')
                            // doc.text('29/07/2021',180,450)
                            doc.save('Certificate.pdf')
                            dispatch({ type: 'open', size: 'mini' })
                        }
                    } target="_blank" type="submit">Get Certificate</Button></center>
                }
        else if(trainingProg === "Hydraulic Modelling of Distribution System (08/09/2021) - Morning"){
            PreTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PreTraining', state: {trainingProg:trainingProg}})} target="_blank" type="submit">Attempt Pre-Questionnaire</Button></center>
            OnlineTrainingButton = <center><a href='https://meet.google.com/gtv-scqg-esq' target="_blank"><Button disabled className="btn1-disabled" variant="outlined" type="submit">Join Google Meet</Button></a></center>
            PostTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PostTraining', state: {trainingProg:trainingProg}})} type="submit">Attempt Post-Questionnaire</Button></center>
            FeedbackButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/Feedback'})} type="submit">Provide Feedback</Button></center>
            CertificateButton = <center><Button className="btn1" variant="outlined" onClick={() => 
                {
                    var doc = new jsPDF('l', 'pt')
                    doc.addImage(certiSS,'png', 10, 10, 820, 570)
                    // doc.setTextColor(0,117,195)
                    doc.setFontSize(14)
                    doc.setFont('arial','normal')
                    doc.text('This is to certify Mr./Ms.',140,346)
                    doc.setFont('arial','bold')
                    doc.text(userName,285,346)
                    doc.setFont('arial','normal')
                    doc.text('has successfully completed his/her training in',140,372)
                    doc.setFont('arial','bold')
                    // doc.text(trainingProg,140,400)
                    doc.text('Hydraulic Modelling of Distribution System',400,372)
                    doc.text('Date: ',140,410)
                    doc.setFont('arial','normal')
                    doc.text('08/09/2021',180,410)
                    doc.setFont('arial','bold')
                    doc.text('Dy. Director, MEETRA ',140,450)
                    doc.text('Director, MEETRA ',550,450)
                    doc.setFont('arial','normal')
                    // doc.text('29/07/2021',180,450)
                    doc.save('Certificate.pdf')
                    dispatch({ type: 'open', size: 'mini' })
                }
            } target="_blank" type="submit">Get Certificate</Button></center>
        }
        else if(trainingProg === "Hydraulic Modelling of Distribution System (13-14/09/2021)"){
            PreTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PreTraining', state: {trainingProg:trainingProg}})} target="_blank" type="submit">Attempt Pre-Questionnaire</Button></center>
            OnlineTrainingButton = <center><a href='https://meet.google.com/aop-pouk-yma' target="_blank"><Button disabled className="btn1-disabled" variant="outlined" type="submit">Join Google Meet</Button></a></center>
            PostTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PostTraining', state: {trainingProg:trainingProg}})} type="submit">Attempt Post-Questionnaire</Button></center>
            FeedbackButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/Feedback'})} type="submit">Provide Feedback</Button></center>
            CertificateButton = <center><Button className="btn1" variant="outlined" onClick={() => 
                {
                    var doc = new jsPDF('l', 'pt')
                    doc.addImage(certiSS,'png', 10, 10, 820, 570)
                    // doc.setTextColor(0,117,195)
                    doc.setFontSize(14)
                    doc.setFont('arial','normal')
                    doc.text('This is to certify Mr./Ms.',140,346)
                    doc.setFont('arial','bold')
                    doc.text(userName,285,346)
                    doc.setFont('arial','normal')
                    doc.text('has successfully completed his/her training in',140,372)
                    doc.setFont('arial','bold')
                    // doc.text(trainingProg,140,400)
                    doc.text('Hydraulic Modelling of Distribution System',400,372)
                    doc.text('Date: ',140,410)
                    doc.setFont('arial','normal')
                    doc.text('13 & 14 September, 2021',180,410)
                    doc.setFont('arial','bold')
                    doc.text('Dy. Director, MEETRA ',140,450)
                    doc.text('Director, MEETRA ',550,450)
                    doc.setFont('arial','normal')
                    // doc.text('29/07/2021',180,450)
                    doc.save('Certificate.pdf')
                    dispatch({ type: 'open', size: 'mini' })
                }
            } target="_blank" type="submit">Get Certificate</Button></center>
        }
        else if(trainingProg === "Hydraulic Modelling of Distribution System (15-16/09/2021)"){
            PreTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PreTraining', state: {trainingProg:trainingProg}})} target="_blank" type="submit">Attempt Pre-Questionnaire</Button></center>
            OnlineTrainingButton = <center><a href='https://meet.google.com/ycq-ybhp-ncz' target="_blank"><Button disabled className="btn1-disabled" variant="outlined" type="submit">Join Google Meet</Button></a></center>
            PostTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PostTraining', state: {trainingProg:trainingProg}})} type="submit">Attempt Post-Questionnaire</Button></center>
            FeedbackButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/Feedback'})} type="submit">Provide Feedback</Button></center>
            CertificateButton = <center><Button className="btn1" variant="outlined" onClick={() => 
                {
                    var doc = new jsPDF('l', 'pt')
                    doc.addImage(certiSS,'png', 10, 10, 820, 570)
                    // doc.setTextColor(0,117,195)
                    doc.setFontSize(14)
                    doc.setFont('arial','normal')
                    doc.text('This is to certify Mr./Ms.',140,346)
                    doc.setFont('arial','bold')
                    doc.text(userName,285,346)
                    doc.setFont('arial','normal')
                    doc.text('has successfully completed his/her training in',140,372)
                    doc.setFont('arial','bold')
                    // doc.text(trainingProg,140,400)
                    doc.text('Hydraulic Modelling of Distribution System',400,372)
                    doc.text('Date: ',140,410)
                    doc.setFont('arial','normal')
                    doc.text('15 & 16 September, 2021',180,410)
                    doc.setFont('arial','bold')
                    doc.text('Dy. Director, MEETRA ',140,450)
                    doc.text('Director, MEETRA ',550,450)
                    doc.setFont('arial','normal')
                    // doc.text('29/07/2021',180,450)
                    doc.save('Certificate.pdf')
                    dispatch({ type: 'open', size: 'mini' })
                }
            } target="_blank" type="submit">Get Certificate</Button></center>
        }
        else if(trainingProg === "Hydraulic Modelling of Distribution System (17-18/09/2021)"){
            PreTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PreTraining', state: {trainingProg:trainingProg}})} target="_blank" type="submit">Attempt Pre-Questionnaire</Button></center>
            OnlineTrainingButton = <center><a href='https://meet.google.com/eer-foyt-mim' target="_blank"><Button disabled className="btn1-disabled" variant="outlined" type="submit">Join Google Meet</Button></a></center>
            PostTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PostTraining', state: {trainingProg:trainingProg}})} type="submit">Attempt Post-Questionnaire</Button></center>
            FeedbackButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/Feedback'})} type="submit">Provide Feedback</Button></center>
            CertificateButton = <center><Button className="btn1" variant="outlined" onClick={() => 
                {
                    var doc = new jsPDF('l', 'pt')
                    doc.addImage(certiSS,'png', 10, 10, 820, 570)
                    // doc.setTextColor(0,117,195)
                    doc.setFontSize(14)
                    doc.setFont('arial','normal')
                    doc.text('This is to certify Mr./Ms.',140,346)
                    doc.setFont('arial','bold')
                    doc.text(userName,285,346)
                    doc.setFont('arial','normal')
                    doc.text('has successfully completed his/her training in',140,372)
                    doc.setFont('arial','bold')
                    // doc.text(trainingProg,140,400)
                    doc.text('Hydraulic Modelling of Distribution System',400,372)
                    doc.text('Date: ',140,410)
                    doc.setFont('arial','normal')
                    doc.text('17 & 18 September, 2021',180,410)
                    doc.setFont('arial','bold')
                    doc.text('Dy. Director, MEETRA ',140,450)
                    doc.text('Director, MEETRA ',550,450)
                    doc.setFont('arial','normal')
                    // doc.text('29/07/2021',180,450)
                    doc.save('Certificate.pdf')
                    dispatch({ type: 'open', size: 'mini' })
                }
            } target="_blank" type="submit">Get Certificate</Button></center>
        }
        else if(trainingProg === "Orientation on JJM with DPR preparation (20/09/2021)"){
            PreTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PreTraining', state: {trainingProg:trainingProg}})} target="_blank" type="submit">Attempt Pre-Questionnaire</Button></center>
            OnlineTrainingButton = <center><a href='https://meet.google.com/igm-yoaj-ffm' target="_blank"><Button disabled className="btn1-disabled" variant="outlined" type="submit">Join Google Meet</Button></a></center>
            PostTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PostTraining', state: {trainingProg:trainingProg}})} type="submit">Attempt Post-Questionnaire</Button></center>
            FeedbackButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/Feedback'})} type="submit">Provide Feedback</Button></center>
            CertificateButton = <center><Button className="btn1" variant="outlined" onClick={() => 
                    {
                        var doc = new jsPDF('l', 'pt')
                        doc.addImage(certiSS,'png', 10, 10, 820, 570)
                        // doc.setTextColor(0,117,195)
                        doc.setFontSize(14)
                        doc.setFont('arial','normal')
                        doc.text('This is to certify Mr./Ms.',140,346)
                        doc.setFont('arial','bold')
                        doc.text(userName,285,346)
                        doc.setFont('arial','normal')
                        doc.text('has successfully completed his/her training in',140,372)
                        doc.setFont('arial','bold')
                        // doc.text(trainingProg,140,400)
                        doc.text('Orientation on JJM with DPR preparation',400,372)
                        doc.text('Date: ',140,410)
                        doc.setFont('arial','normal')
                        doc.text('20/09/2021',180,410)
                        doc.setFont('arial','bold')
                        doc.text('Dy. Director, MEETRA ',140,450)
                        doc.text('Director, MEETRA ',550,450)
                        doc.setFont('arial','normal')
                        // doc.text('29/07/2021',180,450)
                        doc.save('Certificate.pdf')
                        dispatch({ type: 'open', size: 'mini' })
                    }
                } target="_blank" type="submit">Get Certificate</Button></center>
            }
            else if(trainingProg === "Orientation on JJM with DPR preparation (21/09/2021)"){
                PreTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PreTraining', state: {trainingProg:trainingProg}})} target="_blank" type="submit">Attempt Pre-Questionnaire</Button></center>
                OnlineTrainingButton = <center><a href='https://meet.google.com/zsu-ordb-czz' target="_blank"><Button disabled className="btn1-disabled" variant="outlined" type="submit">Join Google Meet</Button></a></center>
                PostTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PostTraining', state: {trainingProg:trainingProg}})} type="submit">Attempt Post-Questionnaire</Button></center>
                FeedbackButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/Feedback'})} type="submit">Provide Feedback</Button></center>
                CertificateButton = <center><Button className="btn1" variant="outlined" onClick={() => 
                        {
                            var doc = new jsPDF('l', 'pt')
                            doc.addImage(certiSS,'png', 10, 10, 820, 570)
                            // doc.setTextColor(0,117,195)
                            doc.setFontSize(14)
                            doc.setFont('arial','normal')
                            doc.text('This is to certify Mr./Ms.',140,346)
                            doc.setFont('arial','bold')
                            doc.text(userName,285,346)
                            doc.setFont('arial','normal')
                            doc.text('has successfully completed his/her training in',140,372)
                            doc.setFont('arial','bold')
                            // doc.text(trainingProg,140,400)
                            doc.text('Orientation on JJM with DPR preparation',400,372)
                            doc.text('Date: ',140,410)
                            doc.setFont('arial','normal')
                            doc.text('21/09/2021',180,410)
                            doc.setFont('arial','bold')
                            doc.text('Dy. Director, MEETRA ',140,450)
                            doc.text('Director, MEETRA ',550,450)
                            doc.setFont('arial','normal')
                            // doc.text('29/07/2021',180,450)
                            doc.save('Certificate.pdf')
                            dispatch({ type: 'open', size: 'mini' })
                        }
                    } target="_blank" type="submit">Get Certificate</Button></center>
                }
            else if(trainingProg === "Hydraulic Modelling of Distribution System (22-23/09/2021)"){
                PreTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PreTraining', state: {trainingProg:trainingProg}})} target="_blank" type="submit">Attempt Pre-Questionnaire</Button></center>
                OnlineTrainingButton = <center><a href='https://meet.google.com/opx-rhgt-gyc' target="_blank"><Button disabled className="btn1-disabled" variant="outlined" type="submit">Join Google Meet</Button></a></center>
                PostTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PostTraining', state: {trainingProg:trainingProg}})} type="submit">Attempt Post-Questionnaire</Button></center>
                FeedbackButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/Feedback'})} type="submit">Provide Feedback</Button></center>
                CertificateButton = <center><Button className="btn1" variant="outlined" onClick={() => 
                    {
                        var doc = new jsPDF('l', 'pt')
                        doc.addImage(certiSS,'png', 10, 10, 820, 570)
                        // doc.setTextColor(0,117,195)
                        doc.setFontSize(14)
                        doc.setFont('arial','normal')
                        doc.text('This is to certify Mr./Ms.',140,346)
                        doc.setFont('arial','bold')
                        doc.text(userName,285,346)
                        doc.setFont('arial','normal')
                        doc.text('has successfully completed his/her training in',140,372)
                        doc.setFont('arial','bold')
                        // doc.text(trainingProg,140,400)
                        doc.text('Hydraulic Modelling of Distribution System',400,372)
                        doc.text('Date: ',140,410)
                        doc.setFont('arial','normal')
                        doc.text('22 & 23 September, 2021',180,410)
                        doc.setFont('arial','bold')
                        doc.text('Dy. Director, MEETRA ',140,450)
                        doc.text('Director, MEETRA ',550,450)
                        doc.setFont('arial','normal')
                        // doc.text('29/07/2021',180,450)
                        doc.save('Certificate.pdf')
                        dispatch({ type: 'open', size: 'mini' })
                    }
                } target="_blank" type="submit">Get Certificate</Button></center>
            }
            else if(trainingProg === "Hydraulic Modelling of Distribution System (24-25/09/2021)"){
                PreTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PreTraining', state: {trainingProg:trainingProg}})} target="_blank" type="submit">Attempt Pre-Questionnaire</Button></center>
                OnlineTrainingButton = <center><a href='https://meet.google.com/jqi-gozm-wxz' target="_blank"><Button disabled className="btn1-disabled" variant="outlined" type="submit">Join Google Meet</Button></a></center>
                PostTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PostTraining', state: {trainingProg:trainingProg}})} type="submit">Attempt Post-Questionnaire</Button></center>
                FeedbackButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/Feedback'})} type="submit">Provide Feedback</Button></center>
                CertificateButton = <center><Button className="btn1" variant="outlined" onClick={() => 
                    {
                        var doc = new jsPDF('l', 'pt')
                        doc.addImage(certiSS,'png', 10, 10, 820, 570)
                        // doc.setTextColor(0,117,195)
                        doc.setFontSize(14)
                        doc.setFont('arial','normal')
                        doc.text('This is to certify Mr./Ms.',140,346)
                        doc.setFont('arial','bold')
                        doc.text(userName,285,346)
                        doc.setFont('arial','normal')
                        doc.text('has successfully completed his/her training in',140,372)
                        doc.setFont('arial','bold')
                        // doc.text(trainingProg,140,400)
                        doc.text('Hydraulic Modelling of Distribution System',400,372)
                        doc.text('Date: ',140,410)
                        doc.setFont('arial','normal')
                        doc.text('24 & 25 September, 2021',180,410)
                        doc.setFont('arial','bold')
                        doc.text('Dy. Director, MEETRA ',140,450)
                        doc.text('Director, MEETRA ',550,450)
                        doc.setFont('arial','normal')
                        // doc.text('29/07/2021',180,450)
                        doc.save('Certificate.pdf')
                        dispatch({ type: 'open', size: 'mini' })
                    }
                } target="_blank" type="submit">Get Certificate</Button></center>
            }
            else if(trainingProg === "Water Quality Monitoring and Survellience (04-05/10/2021)"){
                PreTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PreTraining', state: {trainingProg:trainingProg}})} target="_blank" type="submit">Attempt Pre-Questionnaire</Button></center>
                OnlineTrainingButton = <center><a href='https://meet.google.com/qff-fwko-zfa' target="_blank"><Button disabled className="btn1-disabled" variant="outlined" type="submit">Join Google Meet</Button></a></center>
                PostTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PostTraining', state: {trainingProg:trainingProg}})} type="submit">Attempt Post-Questionnaire</Button></center>
                FeedbackButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/Feedback'})} type="submit">Provide Feedback</Button></center>
                CertificateButton = <center><Button className="btn1" variant="outlined" onClick={() => 
                    {
                        var doc = new jsPDF('l', 'pt')
                        doc.addImage(certiSS,'png', 10, 10, 820, 570)
                        // doc.setTextColor(0,117,195)
                        doc.setFontSize(14)
                        doc.setFont('arial','normal')
                        doc.text('This is to certify Mr./Ms.',140,346)
                        doc.setFont('arial','bold')
                        doc.text(userName,285,346)
                        doc.setFont('arial','normal')
                        doc.text('has successfully completed his/her training in',140,372)
                        doc.setFont('arial','bold')
                        // doc.text(trainingProg,140,400)
                        doc.text('Water Quality Monitoring and Survellience',400,372)
                        doc.text('Date: ',140,410)
                        doc.setFont('arial','normal')
                        doc.text('04 & 05 October, 2021',180,410)
                        doc.setFont('arial','bold')
                        doc.text('Dy. Director, MEETRA ',140,450)
                        doc.text('Director, MEETRA ',550,450)
                        doc.setFont('arial','normal')
                        // doc.text('29/07/2021',180,450)
                        doc.save('Certificate.pdf')
                        dispatch({ type: 'open', size: 'mini' })
                    }
                } target="_blank" type="submit">Get Certificate</Button></center>
            }
    else if(trainingProg === "Hydraulic Modelling of Distribution System (20-21/08/2021)"){
        PreTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PreTraining', state: {trainingProg:trainingProg}})} target="_blank" type="submit">Attempt Pre-Questionnaire</Button></center>
        OnlineTrainingButton = <center><a href='https://meet.google.com/oev-ypxj-ihr' target="_blank"><Button disabled className="btn1-disabled" variant="outlined" type="submit">Join Google Meet</Button></a></center>
        PostTrainingButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/PostTraining', state: {trainingProg:trainingProg}})} type="submit">Attempt Post-Questionnaire</Button></center>
        FeedbackButton = <center><Button disabled className="btn1-disabled" variant="outlined" onClick={() => history.push({pathname:'/Feedback'})} type="submit">Provide Feedback</Button></center>
        CertificateButton = <center><Button className="btn1" variant="outlined" onClick={() => 
            {
                var doc = new jsPDF('l', 'pt')
                doc.addImage(certiSS,'png', 10, 10, 820, 570)
                // doc.setTextColor(0,117,195)
                doc.setFontSize(14)
                doc.setFont('arial','normal')
                doc.text('This is to certify Mr./Ms.',140,346)
                doc.setFont('arial','bold')
                doc.text(userName,285,346)
                doc.setFont('arial','normal')
                doc.text('has successfully completed his/her training in',140,372)
                doc.setFont('arial','bold')
                // doc.text(trainingProg,140,400)
                doc.text('Hydraulic Modelling of Distribution System',400,372)
                doc.text('Date: ',140,410)
                doc.setFont('arial','normal')
                doc.text('20 & 21 August, 2021',180,410)
                doc.setFont('arial','bold')
                doc.text('Dy. Director, MEETRA ',140,450)
                doc.text('Director, MEETRA ',550,450)
                doc.setFont('arial','normal')
                // doc.text('29/07/2021',180,450)
                doc.save('Certificate.pdf')
                dispatch({ type: 'open', size: 'mini' })
            }
        } target="_blank" type="submit">Get Certificate</Button></center>
    }
    else if(trainingProg === "Hydraulic Modelling of Distribution System (11-12/10/2021)"){
        PreTrainingButton = <center><Button className="btn1" variant="outlined" onClick={() => history.push({pathname:'/PreTraining', state: {trainingProg:trainingProg}})} target="_blank" type="submit">Attempt Pre-Questionnaire</Button></center>
        OnlineTrainingButton = <center><a href='https://meet.google.com/cjg-vwih-sov' target="_blank"><Button className="btn1" variant="outlined" type="submit">Join Google Meet</Button></a></center>
        PostTrainingButton = <center><Button className="btn1" variant="outlined" onClick={() => history.push({pathname:'/PostTraining', state: {trainingProg:trainingProg}})} type="submit">Attempt Post-Questionnaire</Button></center>
        FeedbackButton = <center><Button className="btn1" variant="outlined" onClick={() => history.push({pathname:'/Feedback'})} type="submit">Provide Feedback</Button></center>
        CertificateButton = <center><Button className="btn1" variant="outlined" onClick={() => 
            {
                var doc = new jsPDF('l', 'pt')
                doc.addImage(certiSS,'png', 10, 10, 820, 570)
                // doc.setTextColor(0,117,195)
                doc.setFontSize(14)
                doc.setFont('arial','normal')
                doc.text('This is to certify Mr./Ms.',140,346)
                doc.setFont('arial','bold')
                doc.text(userName,285,346)
                doc.setFont('arial','normal')
                doc.text('has successfully completed his/her training in',140,372)
                doc.setFont('arial','bold')
                // doc.text(trainingProg,140,400)
                doc.text('Hydraulic Modelling of Distribution System',400,372)
                doc.text('Date: ',140,410)
                doc.setFont('arial','normal')
                doc.text('11 & 12 October, 2021',180,410)
                doc.setFont('arial','bold')
                doc.text('Dy. Director, MEETRA ',140,450)
                doc.text('Director, MEETRA ',550,450)
                doc.setFont('arial','normal')
                // doc.text('29/07/2021',180,450)
                doc.save('Certificate.pdf')
                dispatch({ type: 'open', size: 'mini' })
            }
        } target="_blank" type="submit">Get Certificate</Button></center>
    }
    return (
        
	<div className="main-container">
        {/* <center><img src={mh} style={{width:"7rem", height:"7rem", padding:"0rem"}}></img></center>
        <div class="flexbox-container">
            <img src={meetra} style={{width:"8rem", height:"8rem"}}></img>
            <center><h1 style={{fontSize:"200%", color:"red"}}>Maharashtra Environmental Engineering Training and Research Academy (MEETRA)</h1></center>
            <img src={india} style={{width:"8rem", height:"8rem"}}></img>
        </div> */}
        <center><img src={heading} width="70%"></img></center>
        <hr/>
        {/* <div className='grid'>
            {docs && docs.map(doc => (
                    <Card style={{ width: '22rem' }} className='box'>
                        <center><Card.Img variant="top" src={doc.image}className='boximg'/></center>
                            <Card.Body>
                            <Card.Text>
                                <center>{doc.title}</center>
                            </Card.Text>
                            <hr/>
                            <center><Button className="btn1" variant="outlined"  href={doc.link} target="_blank" type="submit"></Button></center>
                        </Card.Body>
                    </Card>
                    ))}     
        </div> */}
        <div className="head">
            <h1>Dashboard</h1>
            {/* <Button className="btn1-signout" type="submit" onClick={() => history.push({pathname:'/TrainingDropdown', state: {email: user.email, trainingProg:trainingProg}})}>New Training Registration</Button> */}
            <Button className="btn1-signout" type="submit" onClick={signOutUser}>Sign out</Button></div>
        <hr/>
        {/* <p>Email: {user.email}</p> */}
        
        <p style={{paddingLeft:"2rem", fontSize:'16px'}}>Welcome <i><b>{userName}</b></i></p>
        <p style={{paddingLeft:"2rem", fontSize:'16px'}}>You've registered for <i><b>{trainingProg}</b></i></p>
        {/* <p style={{paddingLeft:"2rem", fontSize:'16px'}}>Please click on the activity you would want to proceed with</p> */}
        <div className='grid'>
            {/* <Card style={{ width: '22rem' }} className='box'>
                <center><Card.Img variant="top" src={attendance} className='boximg'/></center> 
                <Card.Body>
                    <Card.Text>
                        <center>Attendance</center>
                    </Card.Text>
                    <hr/>
                    <center><Button className="btn1-disabled" disabled variant="outlined" onClick={() => history.push({pathname:'/Attendance'})} target="_blank" type="submit">Mark Attendance</Button></center>
                </Card.Body>
            </Card> */}
            <Card style={{ width: '22rem' }} className='box'>
                <center><Card.Header style={{fontSize: '1.3rem'}}><b>Step 1</b></Card.Header></center>
                <center><Card.Img variant="top" src={exam} className='boximg'/></center> 
                <Card.Body>
                    <Card.Text>
                        <center>Pre-Training Questionnaire</center>
                    </Card.Text>
                    <hr/>
                    {PreTrainingButton}
                </Card.Body>
            </Card>
            <Card style={{ width: '22rem' }} className='box'>
            <center><Card.Header style={{fontSize: '1.3rem'}}><b>Step 2</b></Card.Header></center>
                <center><Card.Img variant="top" src={userLogo} className='boximg'/></center> 
                <Card.Body>
                    <Card.Text>
                        <center>Online Training</center>
                    </Card.Text>
                    <hr/>
                    {OnlineTrainingButton}
                </Card.Body>
            </Card>
            <Card style={{ width: '22rem' }} className='box'>
            <center><Card.Header style={{fontSize: '1.3rem'}}><b>Step 3</b></Card.Header></center>
                <center><Card.Img variant="top" src={post} className='boximg'/></center> 
                <Card.Body>
                    <Card.Text>
                        <center>Post-Training Questionnaire</center>
                    </Card.Text>
                    <hr/>
                    {PostTrainingButton}
                </Card.Body>
            </Card>
            <Card style={{ width: '22rem' }} className='box'>
            <center><Card.Header style={{fontSize: '1.3rem'}}><b>Step 4</b></Card.Header></center>
                <center><Card.Img variant="top" src={feedback} className='boximg'/></center> 
                <Card.Body>
                    <Card.Text>
                        <center>Feedback</center>
                    </Card.Text>
                    <hr/>
                    {FeedbackButton}
                    
                </Card.Body>
            </Card>
            <Card style={{ width: '22rem' }} className='box'>
            <center><Card.Header style={{fontSize: '1.3rem'}}><b>Step 5</b></Card.Header></center>
                <center><Card.Img variant="top" src={certificate} className='boximg'/></center> 
                <Card.Body>
                    <Card.Text>
                        <center>Certificate</center>
                    </Card.Text>
                    <hr/>
                    {/* <center><Button className="btn1" disabled variant="outlined"  href='https://docs.google.com/forms/d/e/1FAIpQLSdy0HSH30rOYCKpAOP4Vf5gD4xaQoE4vq6vQwvxT3DkCmUY6Q/viewform?usp=sf_link' target="_blank" type="submit">Get Certificate</Button></center> */}
                    {/* <center><a href={certiPDF} target="_blank"><Button className="btn1" variant="outlined" type="submit">Get Certificate</Button></a></center> */}
                    {CertificateButton}
                </Card.Body>
            </Card>
            {/* <Modal
                                aria-labelledby='modal-label'
                                autoFocus={true}
                                show={isOpen}
                                onHide={()=>setIsOpen(false)}
                                >
                                    <Modal.Header closeButton style={{background:'linear-gradient(to right, #205a58, #2b7a78, #3aafa9)', color:'#feffff'}}>
                                        Alert!
                                    </Modal.Header>
                                    <Modal.Body>
                                        This link will redirect you to a third party website. Are you sure you want to redirect?
                                        <br/><br/>
                                        <center>
                                            <Button variant="outlined" className="btn1" href='' target="__blank" onClick={()=>setIsOpen(false)}>Okay</Button>
                                        </center>
                                    </Modal.Body>
                                </Modal> */}
                                <Modal
                                    closeIcon
                                    size={size}
                                    open={open}
                                    onClose={() => dispatch({ type: 'close' })}
                                >
                                    <Modal.Header style={{background:'linear-gradient(to right, #0a1817, #4e5b62, #82a0ad)', color:'#feffff'}}>e-Certificate Downloaded!</Modal.Header>
                                    <Modal.Content>
                                    <p>Your e-Certificate is auto-downloaded. Please check your downloads folder.</p>
                                    </Modal.Content>
                                    <Modal.Actions>
                                    <Button className='btn1' onClick={() => dispatch({ type: 'close' })}>
                                        Okay
                                    </Button>
                                    </Modal.Actions>
                                </Modal>
        </div>
        <Footer/>
	</div>
);
}